import CourseCatalog from '@/pages/courses/components/CourseCatalog';
import { hospitalCourses } from '@/mocks/home';
import { fetchCourseList } from '@/services/course';
import { adaptCourses } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=Modern%20bright%20hospital%20clinical%20training%20classroom%20with%20physicians%20in%20white%20coats%20studying%20integrated%20Chinese%20and%20Western%20medicine%20around%20a%20long%20table%2C%20glass%20curtain%20wall%20and%20warm%20wood%20tones%2C%20soft%20daylight%2C%20cinematic%20editorial%20photography%20with%20dark%20lower%20area%20for%20text%20overlay&width=1920&height=560&seq=courses-hospital-hero&orientation=landscape';

export default function HospitalCoursesPage() {
  // 接口失败时降级为 mock 数据；只取名院课程（courseType=2）
  const { data } = useRequest(
    () => fetchCourseList({ pageIndex: 1, pageSize: 999, courseType: 2 }).then((res) => adaptCourses(res.list)),
    { fallback: hospitalCourses },
  );

  return (
    <CourseCatalog
      heroImage={HERO_IMAGE}
      eyebrow="名院课程"
      title="名院课程"
      description="联合三甲医院打造临床体系化课程，覆盖中西医结合、专科专病与实用技术，学以致用、即学即用。"
      breadcrumb={[{ label: '首页', to: '/' }, { label: '课程中心' }, { label: '名院课程' }]}
      items={data}
    />
  );
}